import { render, staticRenderFns } from "./ed-pdf-zoom-controls.vue?vue&type=template&id=8b6f1cde&scoped=true&"
import script from "./ed-pdf-zoom-controls.ts?vue&type=script&lang=ts&"
export * from "./ed-pdf-zoom-controls.ts?vue&type=script&lang=ts&"
import style0 from "./ed-pdf-zoom-controls.scss?vue&type=style&index=0&id=8b6f1cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6f1cde",
  null
  
)

export default component.exports